const prefix = 'GLOBAL';

export const SET_MENUS_AUTH = `${prefix}_SET_MENUS_AUTH`;
export const SET_MENUS_AUTH_SUCCESS = `${prefix}_SET_MENUS_AUTH_SUCCESS`;

export const SET_AUTH_INFO = `${prefix}_SET_AUTH_INFO`;
export const SET_ACCOUNT_BALANCE = `${prefix}_SET_ACCOUNT_BALANCE`;
export const SET_ACCOUNT_TYPE = `${prefix}_SET_ACCOUNT_TYPE`;
export const SET_RECHARGE_VISIBLE = `${prefix}_SET_RECHARGE_VISIBLE`;

export default {};
